import { Injectable, Injector } from '@angular/core';


export let InjectorInstance: Injector;

@Injectable({
    providedIn: 'root'
})
export class GlobalService {

    constructor(private readonly injector: Injector) {
        InjectorInstance = this.injector;
    }

}
